__turbopack_context__.v({
  "backButton": "styles-module-scss-module__6WECZq__backButton",
  "button": "styles-module-scss-module__6WECZq__button",
  "container": "styles-module-scss-module__6WECZq__container",
  "item": "styles-module-scss-module__6WECZq__item",
  "menu": "styles-module-scss-module__6WECZq__menu",
  "menuButton": "styles-module-scss-module__6WECZq__menuButton",
  "seeThrough": "styles-module-scss-module__6WECZq__seeThrough",
  "slider": "styles-module-scss-module__6WECZq__slider",
  "submenuHeader": "styles-module-scss-module__6WECZq__submenuHeader",
  "switch": "styles-module-scss-module__6WECZq__switch",
});
